import { Routes, Route, Navigate } from 'react-router-dom'
import { SignedIn, SignedOut, RedirectToSignIn, SignIn, SignUp } from '@clerk/clerk-react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { SuperAdminGate } from '@/components/SuperAdminGate'
import { DashboardHome } from '@/pages/dashboard/DashboardHome'
import { DecisionQueue } from '@/pages/dashboard/DecisionQueue'
import { ActivityLog } from '@/pages/dashboard/ActivityLog'
import { AgentCouncil } from '@/pages/dashboard/AgentCouncil'
import { Loom } from '@/pages/dashboard/Loom'
import { CustomersList } from '@/pages/dashboard/CustomersList'
import { CustomerDetail } from '@/pages/dashboard/CustomerDetail'
import { HealthMonitor } from '@/pages/dashboard/HealthMonitor'
import { CostsPage } from '@/pages/dashboard/CostsPage'
import { ZeusChat } from '@/pages/dashboard/ZeusChat'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  return (
    <>
      <SignedIn>
        <SuperAdminGate>{children}</SuperAdminGate>
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn signInFallbackRedirectUrl="/dashboard" />
      </SignedOut>
    </>
  )
}

function SignInPage() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#0a0a0a' }}>
      <SignIn
        fallbackRedirectUrl="/dashboard"
        signUpFallbackRedirectUrl="/dashboard"
        appearance={{ elements: { rootBox: { width: '100%', maxWidth: '440px' } } }}
      />
    </div>
  )
}

function SignUpPage() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#0a0a0a' }}>
      <SignUp
        fallbackRedirectUrl="/dashboard"
        signInFallbackRedirectUrl="/dashboard"
        appearance={{ elements: { rootBox: { width: '100%', maxWidth: '440px' } } }}
      />
    </div>
  )
}

export default function App() {
  return (
    <Routes>
      {/* ─── Public routes ─── */}
      <Route path="/" element={<Navigate to="/sign-in" replace />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />

      {/* ─── Protected dashboard routes ─── */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardHome />} />
        <Route path="zeus" element={<ZeusChat />} />
        <Route path="decisions" element={<DecisionQueue />} />
        <Route path="activity" element={<ActivityLog />} />
        <Route path="agents" element={<AgentCouncil />} />
        <Route path="loom" element={<Loom />} />
        <Route path="customers" element={<CustomersList />} />
        <Route path="customers/:tenantId" element={<CustomerDetail />} />
        <Route path="costs" element={<CostsPage />} />
        <Route path="health" element={<HealthMonitor />} />
      </Route>

      {/* Catch-all → sign-in */}
      <Route path="*" element={<Navigate to="/sign-in" replace />} />
    </Routes>
  )
}
